import {
  FETCH_APP_USERS_ALL_NOTES,
  OPEN_NOTE_DETAILS,
  SHOW_BACK_NOTES_SCREEN,
  FETCH_APP_USER_NOTES
} from '../actions';

export const appuserNotes = (state = {}, action) => {
  if (action.type === FETCH_APP_USERS_ALL_NOTES) {
    return action.payload;
  }
  return state;
};

export const appUserNotes = (state = {}, action) => {
  switch (action.type) {
    case FETCH_APP_USER_NOTES:
      return action.payload;
    default:
      return state;
  }
};

export const noteDetailsReducer = (state = { show: false }, action) => {
  if (action.type === OPEN_NOTE_DETAILS) {
    return action.payload;
  }
  return state;
};

export const showBackNotesScreenReducer = (state = false, action) => {
  if (action.type === SHOW_BACK_NOTES_SCREEN) {
    return action.payload;
  }
  return state;
};
